class CrmController implements ng.IComponentController {
    
    constructor() {
        'ngInject';
        // console.log('CrmController');
    }
}

export const crmComponent : ng.IComponentOptions = {
    controller : CrmController,
    template : require('./crm.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/crm.component.ts